import React from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
} from "@mui/material";
import {
  getListStatus,
  statusTranslate,
  getAllBrasilStates,
} from "../../utils/advanceRequest";
import { useAutoApplyFilters } from "../../shared/ui/filters/useAutoApplyFilters";

const states = getAllBrasilStates();

const defaultValues = {
  doctorName: "",
  crm: "",
  crmUf: "",
  selectedStatus: [],
  startRequestDate: "",
  endRequestDate: "",
  includeInactive: false,
  registrationPending: false,
};

const TEXT_FIELDS = ["doctorName", "crm"];

// Decisão U1: aplica sozinho (seletores/datas/switch 300 ms, texto 400 ms ou Enter); sem "Aplicar filtros".
// showRegistrationFilter: chave registrationSeal (conversão do ME) — "Só com registro pendente".
const FilterBarAdvanceRequest = ({ onFilterChange, initialFilters, showRegistrationFilter = false }) => {
  const { draft: filters, setField, bindText, flush, clear, hasActive } = useAutoApplyFilters({
    value: { ...defaultValues, ...initialFilters },
    defaults: defaultValues,
    onApply: (next) => onFilterChange?.(next),
    textFields: TEXT_FIELDS,
  });

  const handleInputChange = (event) => setField(event.target.name, event.target.value);

  const handleStatusChange = (event) => {
    const { value } = event.target;
    setField("selectedStatus", typeof value === "string" ? value.split(",") : value);
  };

  // O switch vai para a URL (inativas=1) como os demais filtros.
  const handleIncludeInactive = (event) => setField("includeInactive", event.target.checked);

  return (
    <Box
      component="form"
      role="search"
      aria-label="Filtros das antecipações"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        flush();
      }}
    >
      <Box sx={{ display: "grid", gap: 1.5, gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", alignItems: "center" }}>
        <TextField label="Nome do Médico" name="doctorName" {...bindText("doctorName")} sx={{ gridColumn: { md: "span 2" } }} />
        <TextField label="CRM" name="crm" {...bindText("crm")} />
        <FormControl>
          <InputLabel id="crmuf-select-label">CRMUF</InputLabel>
          <Select id="crmuf" labelId="crmuf-select-label" label="CRMUF" name="crmUf" value={filters.crmUf} renderValue={(s) => s || "Todas"} onChange={handleInputChange}>
            <MenuItem value="">Todas</MenuItem>
            {states.map((state) => <MenuItem key={state.uf} value={state.uf}>{state.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl sx={{ gridColumn: { md: "span 2" } }}>
          <InputLabel id="status-multiple-checkbox-label">Status</InputLabel>
          <Select
            label="Status"
            labelId="status-multiple-checkbox-label"
            id="status-multiple-checkbox"
            multiple
            value={filters.selectedStatus}
            onChange={handleStatusChange}
            renderValue={(selecteds) => selecteds.map((s) => statusTranslate(s)).join(", ")}
            MenuProps={{ PaperProps: { style: { maxHeight: 48 * 4.5 + 8 } } }}
          >
            {getListStatus().map((slug) => (
              <MenuItem key={slug} value={slug} dense>
                <Checkbox size="small" checked={filters.selectedStatus.indexOf(slug) > -1} />
                <ListItemText primary={statusTranslate(slug)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField label="Data Inicial" type="date" name="startRequestDate" value={filters.startRequestDate} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
        <TextField label="Data Final" type="date" name="endRequestDate" value={filters.endRequestDate} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1, mt: 1.5 }}>
        <FormControlLabel
          control={<Switch size="small" checked={Boolean(filters.includeInactive)} onChange={handleIncludeInactive} />}
          label={<Typography sx={{ fontSize: 13 }}>Incluir empresas inativas</Typography>}
        />
        {showRegistrationFilter && (
          <FormControlLabel
            control={<Switch size="small" checked={Boolean(filters.registrationPending)} onChange={(event) => setField("registrationPending", event.target.checked)} />}
            label={<Typography sx={{ fontSize: 13 }}>Só com registro pendente</Typography>}
          />
        )}
        <Box sx={{ flex: 1 }} />
        {hasActive && <Button type="button" onClick={clear}>Limpar filtros</Button>}
      </Box>
    </Box>
  );
};

export default FilterBarAdvanceRequest;
